<template>
  <v-dialog
      transition="dialog-bottom-transition"
      width="40%"
      v-model="dialog">

    <template v-slot:activator="{ props }">
      <v-btn
          data-automationId="newCustomerButton"
          class="newCustomerButton"
          color="primary"
          v-bind="props"
          @click="dialog = true;"
      ><v-icon icon="mdi-pen" color="white"></v-icon></v-btn>
    </template>
    <template v-slot:default>
      <v-card>
        <v-toolbar
            color="primary"
            title="Create a new Customer"
        ></v-toolbar>
        <v-text-field data-automationId="newCustomerName" type="text" label="Title" v-model="name"></v-text-field>
        <v-card-actions class="justify-end">
          <v-btn
              data-automationId="newCustomerCreateButton"
              variant="text"
              @click="createCustomer();"
          >Create Customer</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import {createCustomer} from "@/workshop/workshopFunctions";

export default {
  name: "NewCustomerPopup",
  data() {
    return {
      name: '',
      dialog: false
    }
  },
  methods: {
    createCustomer(){
      createCustomer(this.name).then(() => {
        this.dialog = false;
        this.$emit('customerCreated');
      });
    }
  }
}
</script>

<style scoped>
  .newCustomerButton{
    border-radius: 100%;
    width: 50px;
    height: 50px;
    float: right;
  }
</style>